import { Button, InputGroup, Spinner, SpinnerSize } from "@blueprintjs/core";
import { FormikProps } from "formik";
import { FGCheckboxInput, FGCustomInput, FGEmpty, FieldGroup, FGDateMaskInput } from "nsitools-react";
import * as React from "react";
import * as Yup from "yup";

import { PasswordApi, WebUserApi, WebUserDto } from "../../../../api";
import { FGSRSHDateMaskInput, SmallFormGenerator } from "../../../../components";
import { useApiService, useCrudApi, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";

export interface IPersonWebUserPageProps {
  personId: number;
  editMode: boolean;
}

export const PersonWebUserPage: React.FunctionComponent<IPersonWebUserPageProps> = ({ personId, editMode }) => {
  const { t } = useTl();
  const [password, setpassword] = React.useState<string>("");
  const api = useApiService(WebUserApi);
  const passwordApi = useApiService(PasswordApi);

  const getNewPassword = React.useCallback(
    async (formik: FormikProps<WebUserDto>) => {
      const pass = await passwordApi.getNewPassword();
      setpassword(pass);
      formik.setFieldValue("password", pass);
    },
    [passwordApi]
  );
  const getWebUser = React.useCallback(async () => {
    const person = await api.get(personId);
    return WebUserDto.fromJS({ ...person, password: password });
  }, [api, password, personId]);

  const { data, loading, saving, saveItem } = useCrudApi(
    {
      getApiFn: async () => {
        return await getWebUser();
      },
      saveApiFn: (d) => api.save(d),
      deleteApiFn: (d) => {},
    },
    [personId]
  );

  const FormSchema = React.useMemo(() => {
    return Yup.object().shape({});
  }, []);

  return (
    <>
      <SmallFormGenerator
        initialValues={data}
        onSubmit={saveItem}
        editMode={editMode}
        validationSchema={FormSchema}
        loading={loading}
        showDeleteButton={false}
        saving={saving}
      >
        <FieldGroup columns={2}>
          <FieldGroup columns={1}>
            <FGCheckboxInput name="active" label={t(ETLCodes.Active)} />
            <FGCustomInput name="active" label={t(ETLCodes.General_Password)}>
              {(ctx) => (
                <InputGroup
                  readOnly={true}
                  value={ctx.formik.values?.password}
                  rightElement={
                    loading ? (
                      <Spinner size={SpinnerSize.SMALL} />
                    ) : editMode ? (
                      <Button
                        text={t(ETLCodes.ResetPassword)}
                        rightIcon={"reset"}
                        intent={"primary"}
                        minimal={true}
                        onClick={() => getNewPassword(ctx.formik)}
                      />
                    ) : null
                  }
                />
              )}
            </FGCustomInput>
            {data?.lastConnectionDate ? (
              <FGSRSHDateMaskInput name="lastConnectionDate" label={t(ETLCodes.LastConnectionDate)} readonly />
            ) : (
              <FGCheckboxInput label={t(ETLCodes.LastConnectionDate)} name="lastConnectionDate" readonly />
            )}
          </FieldGroup>
          <FGEmpty />
        </FieldGroup>
      </SmallFormGenerator>
    </>
  );
};
